import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { getDownloadUsageFields } from '../../actions/umoUtils';
import { ModalFooter, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from '../ui/Button';
import { sendUsageData } from '../../utils/piction';
import { downloadURL } from '../../utils/umoUtils';

const DownloadUsageView = ({ usageFields, data, userEmail, dispatch, hideDialog, intl }) => {
  useEffect(() => {
    if (!usageFields) { dispatch(getDownloadUsageFields()) }
  });

  const [checkedValues, setCheckValue] = useState({});
  const [isError, setError] = useState(false);
  const [dynamicEmail, setEmail] = useState(userEmail || '');
  const [emailError, setEmailError] = useState(false);

  const handleCheckboxChange = (e, field) => {
    const { name, checked } = e.target;
    const fieldsList = checkedValues;
    let values = fieldsList[field] || [];
    if (checked) {
      if (values) values.push(name)
      else values = [name];
    }
    else {
      values = values.filter(val => val !== name);
    }
    fieldsList[field] = values.length > 0 ? values : null;
    setCheckValue(fieldsList);
  };

  const handleInputChange = (e, field) => {
    const fieldsList = checkedValues;
    checkedValues[field] = e.target.value;
    setCheckValue(fieldsList);
  }

  const onDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const options = {};
    try {
      if (usageFields) {
        usageFields.forEach(item => {
          if (!checkedValues[item.name] && item.mandatory) {
            throw new Error('general.fillMandatory');
          } else if (Array.isArray(checkedValues[item.name])) {
            options[item.name] = checkedValues[item.name].toString();
          } else if (item.ruleGroup.includes('EMAIL') &&
            !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(checkedValues[item.name]))) {
            throw new Error('general.invalidEmail');
          } else {
            options[item.name] = checkedValues[item.name];
          }
        });
        setError(false);
      }
      if (data.isDynamic && (!dynamicEmail || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dynamicEmail)))) {
        setEmailError('general.invalidEmail');
        return false;
      } else {
        setEmailError(false);
      }
      sendUsageData(data.umoID, options, dispatch);
      downloadURL(data.url, data.name, dispatch, data.isDynamic, dynamicEmail);
      hideDialog();
    } catch(e) {
      setError(e.message);
      return false;
    }
  };
  const getFieldData = (item) => {
    if (item.ruleGroup.includes('CHECKBOX')) {
      return item.lovValue.map(option => {
        const chkOption = option.split('[')[0];
        return (<div key={`${name}_${chkOption}`} className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id={chkOption}
            onChange={ e => handleCheckboxChange(e, item.name)}
            name={chkOption}
            value={chkOption}
            style={{ width: '350px' }}
          />
          <label htmlFor={chkOption} className="form-check-label">{chkOption}</label>
        </div>)
      })
    } else if (item.ruleGroup.includes('DATE')) {
      return (<label key={item.name}>
        <input
          type="date"
          className="form-control"
          onChange={ e => handleInputChange(e, item.name)}
          name={item.name}
          value={item.value} />
      </label>);
    } else if (item.ruleGroup.includes('EMAIL')) {
      return (<label key={item.name}>
        <input
        type="email"
        className="form-control"
        onChange={ e => handleInputChange(e, item.name)}
        name={item.name}
        value={item.value} />
      </label>);
    } else if (item.ruleGroup.includes('TEXTAREA')) {
      return (<div key={item.name}>
      <textarea
        className="form-control"
        style={{ height: '100px' }}
        onChange={ e => handleInputChange(e, item.name)}
        value={item.value}
      />
      </div>);
    } else {
      return (<label key={item.name}>
        <input
          type="text"
          onChange={e => handleInputChange(e, item.name)}
          name={item.name}
          value={item.value}/>
      </label>);
    }
  }
const dynamicEmailTooltip = (<Tooltip id="dynamic-email__tooltip">
  {intl.formatMessage({ id: 'workspaceDownloadDialog.emailDynamicDownload' })}
</Tooltip>);
  const dynamicEmailOverlay = (<OverlayTrigger
    key="dynamic-email__tooltip"
    overlay={dynamicEmailTooltip}
    placement="right"
  >
    <span style={{ marginLeft: '5px' }}><i className="far fa-question-circle" /></span>
  </OverlayTrigger>);

  return (
    <form className="share-view__modal" onSubmit={onDownload} noValidate>
      <div className="workspace-dialog__form-header">
        {intl.formatMessage({ id: 'workspaceDownloadDialog.mainTitle' })}
      </div>
      {usageFields && usageFields.map(item =>
        <div key={item.name} className="form-group">
          <h6>{`${item.name}${item.mandatory ? '*' : ''}`}</h6>
          {getFieldData(item)}
        </div>)
      }
      {data.isDynamic ?
        <div>
          < br/>
          <div key="dynamic_deriv_email" className="form-group">
            <h6>
              *{intl.formatMessage({ id: 'workspaceEmailDialog.toEmailPlaceholder'})}
              {dynamicEmailOverlay}
            </h6>
            <label key="test">
              <input
                type="email"
                className="form-control"
                onChange={ e => setEmail(e.target.value)}
                style={{ borderColor: emailError ? 'red' : '#ced4da'}}
                value={dynamicEmail}
                required
              />
            </label>
            {emailError ?
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {intl.formatMessage({ id: emailError })}
              </div> : null
              }
          </div>
        </div>
        : null}
      <ModalFooter>
        {isError ?
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {intl.formatMessage({ id: isError })}
        </div> : null
        }
        <Button type="submit" variant="primary">
          {intl.formatMessage({ id: 'workspaceDownloadDialog.buttonDownload' })}
        </Button>
        <Button onClick={hideDialog}>
          {intl.formatMessage({ id: 'categoryMoveDialog.cancelButton' })}
        </Button>
      </ModalFooter>
    </form>
  );
};

DownloadUsageView.propTypes = {
  umoUtils: PropTypes.instanceOf(Map),
  hideDialog: PropTypes.func,
  dispatch: PropTypes.func,
  data: PropTypes.instanceOf(Object),
  userEmail: PropTypes.string,
};

export default injectIntl(DownloadUsageView);




// WEBPACK FOOTER //
// ./src/js/components/UMODownloadView/DownloadUsageView.jsx